import { Store } from 'vuex'
import { AxiosError, AxiosInstance } from 'axios'
import { State as StoreState } from '@/store/index'
import { instanceNoAuth } from '@/model/api/apibase'
import { ErrorResponse } from '@/model/api/error/erroResponse'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'
import { useApiError } from '@/model/api/error/apiError'
import API_URL from '@/model/api/apiUrlType'
import * as log from '@/model/util/log/Logger'

// リクエストデータ
type RequestData = {
  // ユーザー名
  username: string
}

// レスポンスデータ
type ResponseData = {
  // ユーザー登録状態
  userstatus: string
}

// ユーザーステータス定義
const USER_STATUS = {
  ENTRY: 'entry', // 登録済み
  PREENTRY: 'preentry', // 仮登録中
} as const
type USER_STATUS = typeof USER_STATUS[keyof typeof USER_STATUS]

/**
 * 応答レスポンスのチェックを実施する
 * 想定外のデータまたは未設定の場合はfalseを返す
 * @param input ステータス
 * @returns true:ステータス正常、false:ステータス異常
 */
const statusCheck = (input: string) => {
  switch (input) {
    case USER_STATUS.ENTRY:
    case USER_STATUS.PREENTRY:
      return true
    default:
      return false
  }
}

/**
 * メールアドレス認証の関数を返す
 * @param store vuex
 * @returns メールアドレス認証の関数
 */
const useUserPrelogin = (store: Store<StoreState>) => {
  // API通信インスタンス
  const instance: AxiosInstance | undefined = instanceNoAuth(store)

  /**
   * メールアドレス認証のAPIを実施
   * @param error エラーメッセージ状態
   */
  const post = async (error: ErrorMsgState) => {
    // 戻り値
    let normaldata: ResponseData | undefined
    // リクエストデータ設定
    const request: RequestData = {
      username: store.state.screen.top.username,
    }
    // 認証後のaxiosインスタンス取得
    const obj = instance
    await obj
      .post<ResponseData>(
        API_URL.USERS.LOGIN, // URL
        request // リクエストデータ
      )
      .then((response) => {
        // 応答レスポンスのユーザーステータスが異常の場合はシステムエラーとする
        if (!statusCheck(response.data.userstatus)) {
          log.warn(`Illegal user status. status:${response.data.userstatus}, url:${API_URL.USERS.LOGIN}`)
          useApiError().setsystemError(error)
        } else {
          // 応答レスポンスが正常の場合はそのまま設定
          normaldata = response.data
        }
      })
      .catch(async (e: AxiosError<ErrorResponse>) => {
        // 異常時はエラーメッセージを設定する
        await useApiError().setbaseError(e, error)
      })
    return {
      normaldata,
    }
  }
  return {
    instance,
    post,
  }
}

export {
  useUserPrelogin, //
  USER_STATUS,
}
